const Reflux = require("reflux");
const ProductsBestSellersActions = require("../actions/products-best-sellers-actions");

const ProductsBestSellersStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    type: "total_value",
    group: "product",
    data: {
      products: [{
        name: "-",
        count: "-",
        percentage: "-"
      }]
    }
  },

  init: function() {
    this.listenTo(ProductsBestSellersActions.fetchData, this.onFetchStarted);
    this.listenTo(ProductsBestSellersActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(ProductsBestSellersActions.fetchData.failed, this.onFetchFailed);
    this.listenTo(ProductsBestSellersActions.changeType, this.onTypeChanged);
    this.listenTo(ProductsBestSellersActions.changeGroup, this.onGroupChanged);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        products: data.best_sellers
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function() {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  },

  onTypeChanged: function(selected) {
    this.state.type = selected.value;

    this.trigger(this.state);
  },

  onGroupChanged: function(selected) {
    this.state.group = selected.value;

    this.trigger(this.state);
  }
});

module.exports = ProductsBestSellersStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/products-best-sellers-store.js